export const admissionProcessTabs = [
  {
    id: "on-campus",
    name: "Очная форма",
  },
  {
    id: "online",
    name: "Дистанционная (онлайн) форма",
  },
];

export const admissionProcessStepsOnCampus = {
  stepOne: "Отправьте \n документы",
  stepTwo: "Оплатите \n обучение",
  stepThree: "Получите \n приглашение",
  stepFour: "Получение \n учебной визы",
  stepFive: "Прибытие на \n Мальту",
};

export const admissionProcessStepsOnline = {
  stepOne: "Подача онлайн-\nзаявки",
  stepTwo: "Письмо о возможности \n зачисления",
  stepThree: "Оплатите \n обучение",
  stepFour: "Регистрация",
  stepFive: "Начните \n обучение",
};

// export const admissionProcessStepsShortCourses = {
//   stepOne: "Send Scanned Copies of your Document3",
//   stepTwo: "Send Scanned Copies of your Document3",
//   stepThree: "Send Scanned Copies of your Document3",
//   stepFour: "Send Scanned Copies of your Documen3t",
//   stepFive: "Send Scanned Copies of your Document3",
// };
